// extracted by mini-css-extract-plugin
export var wrapper = "homieCard-module--wrapper--3yuEX";
export var info = "homieCard-module--info--w0SNZ";
export var name = "homieCard-module--name--1SXyL";
export var desc = "homieCard-module--desc--gYjgg";
export var link = "homieCard-module--link--3eu3k";
export var image = "homieCard-module--image--VI1tI";